export default __webpack_public_path__ + "static/media/check2.e929abaa.svg";